import _ from "lodash";
import React from "react";
import PropTypes from "prop-types";

// Components
import I18nHOC from "UIComponents/I18nHOC";
import EmptyField from "UIComponents/EmptyField";
import EmptyView from "UIComponents/EmptyView/EmptyView";
import UIBaseComponent from "UIComponents/UIBaseComponent";
import ListItem from "./ListItem";

// third party - replaced shortid with nanoid
import { nanoid } from "nanoid";

// DS
import { NoFoldersIllustration } from "@toddle-edu/ds-theme";

// Scss
import classes from "./LearningIntentions.scss";

class LearningIntentions extends UIBaseComponent {
  constructor(props) {
    super(props);
    this.contentEditableRefs = React.createRef();
    this.contentEditableRefs.current = {};
  }

  componentDidMount = () => {
    const { value } = this.props;

    if (_.size(value) == 0) {
      this.handleInit();
    }

    if (this.shouldShowEditEmpty()) {
      this.updateValue([{ id: nanoid(10), value: "" }]);
    }
  };

  handleInit = () => {
    const { options, shouldInitOptions } = this.props;
    if (shouldInitOptions && options.length > 0) {
      this.updateValue(
        _.map(options, option => {
          return { id: option.value, value: option.label, isSelected: false };
        })
      );
    } else {
      this.updateValue([{ id: nanoid(10), value: "" }]);
    }
  };

  componentDidUpdate = prevProps => {
    if (
      _.get(this.props.value, "length", 0) == 0 ||
      !_.isEqualWith(prevProps.options, this.props.options, "id")
    ) {
      this.handleInit();
    }
  };

  shouldShowEditEmpty = () => {
    const { options, shouldInitOptions } = this.props;
    if (shouldInitOptions) {
      return _.get(options, "length", 0) == 0;
    } else {
      return false;
    }
  };

  renderEditEmpty = () => {
    const { emptyText, emptyEditText } = this.props;
    return <EmptyField title={emptyEditText || emptyText} />;
  };

  renderViewEmpty = () => {
    const { emptyText } = this.props;
    return (
      <EmptyView
        emptyImageUrl={NoFoldersIllustration}
        emptyHeaderText={emptyText}
        size="small"
      />
    );
  };

  getValue = () => {
    const { value, mode } = this.props;

    if (mode === "view") {
      return _.filter(value, item => !_.isEmpty(item?.value));
    }

    return value;
  };

  renderIntentions = () => {
    const { customContentEditableStyle = {} } = this.props;

    const value = this.getValue();

    return (
      <div className={classes.droppableWrapper}>
        {_.map(value, (item, index) => (
          <ListItem
            {...this.props}
            value={value}
            key={item.id}
            item={item}
            index={index}
            onChange={value => this.updateValue(value)}
            contentEditableRefs={this.contentEditableRefs}
            customContentEditableStyle={customContentEditableStyle}
          />
        ))}
      </div>
    );
  };

  renderView = () => this.renderIntentions();
  renderEdit = () => this.renderIntentions();
}

LearningIntentions.defaultProps = {
  ...UIBaseComponent.defaultProps,
  showListItemNumber: true,
  shouldInitOptions: false,
};

LearningIntentions.propTypes = {
  ...UIBaseComponent.propTypes,
  showListItemNumber: PropTypes.bool,
  shouldInitOptions: PropTypes.bool,
};

export default I18nHOC({ resource: "common" })(LearningIntentions);
